import React from 'react';
import { Link } from 'react-router-dom';
import TablePagination from '@mui/material/TablePagination';
import { Badge } from 'react-bootstrap';
import { Button, Card, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

const CompanyOrgMemberTable = ({
  rowData,
  colName,
  dataFrame,
  sortBy = null,
  delFunc = null,
  editModalOpen = null,
  ...props
}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [orderBy, setOrderBy] = React.useState('');
  const [order, setOrder] = React.useState('');
  const dispatch = useDispatch();

  const handleSortRequest = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  // Comparator function generator based on the order and orderBy properties
  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  // Function to stabilize and sort the rows based on the specified comparator
  const sortedRowInformation = (rowArray, comparator) => {
    // Sort the row array using the provided comparator
    const sortedRows = [...rowArray].sort(comparator);
    return sortedRows;
  };
  const handleButtonClick = (index, direction) => {
    handleSortRequest(sortBy[index]);
    const buttons = document.querySelectorAll('.arrow-button');
    buttons.forEach((button, i) => {
      button.style.color = '#E2E2E2'; // Set color to default
    });
    document.getElementById(`arrow-button-${index}-${direction}`).style.color = 'black';
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getValueFromNestedObject = (obj, keyPath) => {
    return keyPath.split('.').reduce((acc, key) => acc && acc[key], obj);
  };

  return (
    <React.Fragment>
      <TableContainer sx={{ border: 1, borderColor: '#E2E2E2',  maxHeight: '65vh'  }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead
            sx={{
              '& .MuiTableCell-head': {
                backgroundColor: '#E2E2E2',
                padding: '10px 16px',
              },
            }}
          >
            <TableRow>
              {colName.map((val, index) => (
                <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                  {val}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowData.length > 0 ? (
              (sortBy !== null ? sortedRowInformation(rowData, getComparator(order, orderBy)) : rowData)
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((val, index) => (
                  <TableRow key={index} hover>
                    {dataFrame.map((frameVal, frameIndex) =>
                      frameVal.hasOwnProperty('isClick') ? (
                        <TableCell key={frameIndex} style={{ width: '27%', padding: '10px 0px 10px 5px', whiteSpace: 'nowrap'}}>
                          <>
                            <Button
                              style={{
                                color: '#323232',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                padding: '5px 0px'
                              }}
                              variant="text"
                              onClick={() => {
                                editModalOpen(val.uuid);
                              }}
                            >
                              設為主管
                            </Button>
                            <Button
                              style={{
                                color: '#323232',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                padding: '5px 0px',
                              }}
                              variant="text"
                              onClick={() => {
                                delFunc(val.uuid);
                              }}
                            >
                              刪除
                            </Button>
                          </>
                        </TableCell>
                      ) : (
                        <TableCell
                          key={frameIndex}
                          style={{
                            width:
                              frameIndex === 0 ? '25%' :
                              frameIndex === 1 ? '45%' :
                              'auto',
                            padding: '10px 8px'
                          }}
                        >
                          {getValueFromNestedObject(val, frameVal.keyName)}
                        </TableCell>
                      )
                    )}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell>查無資料</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        className="mt-3"
        component="div"
        rowsPerPageOptions={[5, 10, 20]}
        count={rowData.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        labelRowsPerPage="每頁顯示 :"
        onRowsPerPageChange={handleChangeRowsPerPage}
        SelectProps={{
          renderValue: (value) => (value === rowData.length ? 'All' : value),
          MenuProps: {
            disablePortal: true,
            PaperProps: {
              sx: {
                zIndex: 1500,
              },
            },
          },
        }}
        sx={{
          '.MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel': {
            marginTop: '1em',
            marginBottom: '1em',
          },
        }}
      />
    </React.Fragment>
  );
};
export default CompanyOrgMemberTable;

CompanyOrgMemberTable.propTypes = {
  // table的資料
  rowData: PropTypes.array.isRequired,
  // table欄位顯示名稱
  colName: PropTypes.array.isRequired,
  // 如何取得table的資料
  dataFrame: PropTypes.arrayOf(
    PropTypes.shape({
      keyName: PropTypes.string.isRequired,
    })
  ).isRequired,
};

CompanyOrgMemberTable.defaultProps = {};
